import { useTranslation } from '@exam-room/translations';

import { TableDataCell, TableHeaderCell, TableRow } from '../../../../../components';

import { columns } from './columns';
import { type TableRowData } from './types';

interface ExamPreviewResultPartScoreTableProps {
  rows: TableRowData[];
}

export default function ExamPreviewResultPartScoreTable(
  props: Readonly<ExamPreviewResultPartScoreTableProps>,
) {
  const { rows } = props;

  const { t } = useTranslation();

  return (
    <div className='w-full'>
      <div className='border-border-divider overflow-hidden rounded-lg border'>
        <table className='w-full'>
          <thead>
            <TableRow className='bg-gray-100'>
              {columns.map((column) => (
                <TableHeaderCell align='left' className={column.cellClassName} key={column.field}>
                  {t(column.headerName)}
                </TableHeaderCell>
              ))}
            </TableRow>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <TableRow key={row.details}>
                <TableDataCell key={`part-${index}`}>{row.details}</TableDataCell>
                <TableDataCell key={`score-${index}`}>{row.score}</TableDataCell>
                <TableDataCell key={`totalScore-${index}`}>{row.totalScore}</TableDataCell>
              </TableRow>
            ))}
          </tbody>
          <tfoot>
            <TableRow className='border-0'>
              <TableDataCell className='font-semibold'>
                {t('examPreviewResultPartScoreTable.concluded')}
              </TableDataCell>
              <TableDataCell className='font-semibold'>
                {rows.reduce((acc, row) => acc + Number(row.score), 0)}
              </TableDataCell>
              <TableDataCell className='font-semibold'>
                {rows.reduce((acc, row) => acc + Number(row.totalScore), 0)}
              </TableDataCell>
            </TableRow>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
